import { render, staticRenderFns } from "./BodyItem.vue?vue&type=template&id=1a78d6d2&scoped=true&"
import script from "./BodyItem.vue?vue&type=script&lang=js&"
export * from "./BodyItem.vue?vue&type=script&lang=js&"
import style0 from "./BodyItem.vue?vue&type=style&index=0&id=1a78d6d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78d6d2",
  null
  
)

export default component.exports